module.exports = __webpack_public_path__ + "static/david-lamp-1521e7e78c8a6fe6e391b944aea6727e.jpg";